import Flex from '@components/Flex/Flex';
import Text from '@components/Text/Text';
import { SvgIconTypeMap } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { BoxProps } from '@mui/system';
import { SVGProps } from 'react';
import { ActiveStrip, Container } from './MenuItem.styles';

interface MenuItemProps extends BoxProps {
  label: string;
  Icon:
    | React.FC<SVGProps<SVGSVGElement>>
    | (OverridableComponent<SvgIconTypeMap<{}, 'svg'>> & { muiName: string });
  onClick: () => void;
  active?: boolean;
}

const MenuItem: React.FC<MenuItemProps> = ({
  label,
  Icon,
  onClick,
  active = false,
  ...restProps
}) => {
  return (
    <Container {...restProps} onClick={onClick} flex={1} active={active}>
      <ActiveStrip data-testid='active-strip' active={active} />
      <Flex flex={1} marginLeft={11} alignItems='center'>
        <Icon width={20} height={20} />
        <Text
          flex={1}
          marginLeft={11}
          variant='h6'
          fontWeight='fontWeightMedium'
        >
          {label}
        </Text>
      </Flex>
    </Container>
  );
};

export default MenuItem;
